/**
 * 相談ステータス
 * @version 1.0
 */
export const FormStatus = {
    
    /** 無し */
    None : '',

    /** 相談情報登録済 */
    // Registered : '0100',

    /** 相談窓口確認中 */
    // ConsultantChecking : '0110',

    /** 事実確認中 */
    ConfirmingFact : '0200',

    /** 相談情報差戻し */
    // Remanded : '0101',   
    
    /** 処遇決定者確認中 */
    // DMChecking : '0300',

    /** 相談者承認待ち */
    // ConsulterEndorsing : '0400',

    /** 完了 */
    AllDone : '9000'
}


// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/form-status/form-status.constants.ts